import React from 'react'
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained'
import Input from '@ntuctech/devex-tangram/Input'
import ButtonIcon from '@ntuctech/devex-tangram/Button/ButtonIcon'
import SvgInfo from '@ntuctech/devex-tangram/Icon/SvgInfo'
import { SvgLoading } from '@ntuctech/devex-tangram/Icon'
import CardInfoModal from './CardInfoModal'
import { Subtitle } from './styled'

const PromptPlusCard = ({
  cardInputHelpText,
  isLoading,
  plusCardNumber,
  send,
  showCardInfoModal,
}) => (
  <>
    <Subtitle>Please enter your Link Rewards card number below.</Subtitle>
    <Input
      data-testid="card-number-input"
      disabled={isLoading}
      error={!!cardInputHelpText && !isLoading}
      fullWidth
      helpText={cardInputHelpText}
      isMasked
      label="Link Rewards card number"
      mask="9999 9999 9999 9999"
      onBlur={() => send({ type: 'ON_BLUR_CARD_INPUT_FIELD' })}
      required
      type="text"
      value={plusCardNumber}
      inputIcon={
        <ButtonIcon
          data-testid="card-info-button"
          onClick={() => send({ type: 'TOGGLE_CARD_INFO_MODAL' })}
          color="grey"
          type="button"
        >
          <SvgInfo />
        </ButtonIcon>
      }
      onChange={e =>
        send({ type: 'ONCHANGE_PLUS_CARD_NUMBER', value: e.target.value })
      }
    />
    <ButtonContained
      data-testid="next-button"
      disabled={!plusCardNumber || !!cardInputHelpText || isLoading}
      fullWidth
      onClick={() => send({ type: 'VERIFY_CARD_NUMBER' })}
    >
      {isLoading ? (
        <SvgLoading data-testid="loading-spinner" color="#1454b8" />
      ) : (
        'Next'
      )}
    </ButtonContained>
    <CardInfoModal
      onClose={() => send({ type: 'TOGGLE_CARD_INFO_MODAL' })}
      open={showCardInfoModal}
    />
  </>
)

export default PromptPlusCard
